module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "ch21"
    }
  }), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#ch21"
    }
  }, [_c('b', [_vm._v("Why’s It Called That?")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Canned herring are called sardines because the canning process was developed in Sardinia.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Producer Terry Melcher wrote “(untitled)” as a placeholder for the name of the Byrds’ ninth album. It mistakenly went to press with the title "), _c('i', [_vm._v("(Untitled)")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("In the 1920s, the nickname “the Big Apple” was popularized by New York newspaper columnist John J. FitzGerald.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Pink Floyd got its name from two Georgia bluesmen, “Pink” Anderson and Floyd Council.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("The original “quisling” (traitor) was Norwegian fascist Vidkun Quisling, who helped the Nazis invade his own country.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("The word “maverick” came into common use in 1845. It referred to unbranded cattle owned by Texas rancher Samuel Maverick.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("The term “ritzy” comes from the posh European hotels run by Swiss innkeeper César Ritz.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_c('i', [_vm._v("Billboard")]), _vm._v(" magazine was founded in 1894 as a trade publication for people who manufactured and used billboards.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Bingo was originally called “beano” because players used beans to mark their cards.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("In golf, the word “green” once meant the entire course.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("The Pet Shop Boys claim they titled their album "), _c('i', [_vm._v("Please")]), _vm._v(" so people would have to ask for it politely.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("The word “aftermath” was originally “aftermowth,” and it referred to the new growth of grass after mowing.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("“Acid rock,” “country rock,” and “hard rock” were all geological terms before they were musical genres.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b3fbbe72","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter21.vue
// module id = 135
// module chunks = 0